<template>
  <v-container class="main-container">
    <div class="main-content-area">
        <v-row justify="center">
          <v-col cols="8">
              <v-text-field
                  v-model="keyword"
                  label="　キーワードを入力してください（関連する記事を検索できます）"
                  solo
                  hide-details
                  height="65"
                  class="mt-2 mb-4"
                  type="text"
                  clearable
                  append-icon="mdi-magnify"
                  background-color="white"
                  v-disabled-icon-focus
              ></v-text-field>
          </v-col>
        </v-row>
        
        <!--【パンくずリスト】-->
        <v-row justify="center">
          <v-col cols="8">
            <v-breadcrumbs :items="items">
               <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :href="item.href"
                  :disabled="item.disabled"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </v-col>
        </v-row>
       
    		<v-row justify="center">
  				<v-col cols="8">
  					<v-card 
                class="mx-auto mt-2 mb-4 py-6 px-6"
                outlined 
                hover
                v-for="(article, idx) in search_articles"
                :key="idx"
                @click="details(article.id)"
              >
  					    <v-card-title v-html="highLight(article.title)"></v-card-title>
								<v-card-subtitle v-html="highLight(article.article_details)"></v-card-subtitle>
            </v-card>
  				</v-col>
  			</v-row>        
  			
        </div>
    </v-container>
</template>

<script>
  export default {
    props: {
        results: {
          type: Array,
        },
        val: {
          type: Object,
        }
    },  
    data: () => ({
      keyword: '',
      // パンくずリスト
      items: [
          {
            text: 'ヘルプ記事検索',
            disabled: false,
            href: '/documents/help',
          },
          {
            text: 'title',
            disabled: true,
            href: '',
          },
        ],
    }),
    methods:{
      // 検索ボックスに入力されたワードに紐づく記事を表示
      // そのワードに黄色マーカー＆太字に
      highLight(text){
        let searchWord = this.keyword?.trim();
        if (!searchWord) return text;
        if (!text.includes(searchWord)) return text;
        const re = new RegExp(searchWord, 'ig');
        return text.replace(re,function(keyword){
        return '<span style="background-color:yellow;font-weight:bold">'+ keyword + '</span>';
        });
      },
      // ヘルプ記事の中身を表示
      details(id) {
        location.href = "/documents/help_article/view/" + id;
      },
    },
    // ヘルプ全記事を初期表示
    computed: {
      search_articles(){
        let searchWord = this.keyword?.trim();
        if (!searchWord) return this.results;
        return this.results.filter(article => {
            return article.title.includes(searchWord) ||
            article.article_details.includes(searchWord) ;
        });
      }
    },
    // 選択されたカテゴリ・キーワードをパンくずリスト2番目に表示
    mounted() {
      this.items[1].text = this.val.category_name;
    },
};
</script>

<style scoped>
    .main-container {
        font-size: 18px !important;
        margin-right: 0px !important;
        margin-left: 0px !important;
        max-width: none !important;
        height: 100% !important;
    }
    .main-content-area {
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }
</style>
